import React from 'react';

import { Checkbox } from './styled';

function CheckboxComponent({
  iconSize = '24px',
  ...props
}) {
  return (
    <Checkbox
      {...props}
      type="checkbox"
      iconSize={iconSize}
    />
  );
}

export default CheckboxComponent;
